import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compose__style_text_italic",
  "use": "compose__style_text_italic-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"compose__style_text_italic\">\n  <title>Italic</title>\n  <text dominant-baseline=\"central\" font-style=\"italic\" x=\"9.2\" y=\"10.4\" text-anchor=\"middle\">I</text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol